import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "crypto",
  "name": "Crypto",
  "category": "utilities",
  "description": "Hash, encrypt, and decrypt data",
  "icon": "Lock",
  "color": "gray",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Crypto",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "crypto",
    "hash",
    "encrypt",
    "decrypt",
    "security",
    "md5",
    "sha256"
  ]
};

export default definition;
